<template>
	<div>
		<headinfo></headinfo>
		<!--中间内容-->
		<div class="center container">
		    <div class="center-nav">
		        <span class="hidden-xs">您的位置：</span>
		        <a href="/index.html">首页</a><i>&gt;</i>
		        <a title="人员风采" href="#">人员风采</a>
		    </div>
		    <div class="center-container">
		        <div class="center-container-left">
		            <div class="center-container-left-Ltitle">
		                <ul>
		                    <li>
		                        <a class="active" title="人员风采" >人员风采</a>
		                    </li>
		                </ul>
		                <div class="left-pic">
		                    <img src="./../assets/img/left-pic.png" alt="">
		                </div>
		            </div>
		        </div>
		        <div class="center-container-right">
		            <div class="center-container-right-title">
		                <span class="title">人员风采</span>
		            </div>
		            <div class="center-container-right-words">
		                <h2>河北省邯郸市诚信公证处人员简介</h2>
		                <div class="people-pic">
		                    <!-- 显示模态框 -->
		                    <!-- 模态框 -->
		
							<el-dialog
							 custom-class="ryjjdialog"
							  title=""
							  :visible.sync="open" v-if="info"
							  width="33%" :show-close="false">
							<!-- Modal content -->
							    <div class="modal-header">
							        <div class="headder-left">
							            <img :src="hoturl+info.nameImg" alt="">
							        </div>
							        <div class="headder-right">
							            <div class="right-name">{{info.name}}</div>
							            <div class="right-zhiwei">{{info.duties}}</div>
							            <div class="right-danwei">河北省邯郸市诚信公证处</div>
							        </div>
							    </div>
							    <div class="modal-body">
							        <div class="body-top">人员介绍：</div>
							        <div class="body-down" v-html="info.content">
							        </div>
							    </div>
							</el-dialog>
							
		                    <!-- 公证员、助理 -->
		                    <!-- <div class="mtjj-top1">
		                        <span>公证员、助理</span>
		                    </div> -->
		                    <div class="down-box">
		                        <div class="gzy" v-for="(item,index) in tabledata" :key="index">
		                            <img @click="showimg(item.id)" :src="hoturl+item.nameImg" alt=""><br>
		                            <span>{{item.name}}({{item.duties}})</span>
		                        </div>
		                    </div>
		                </div>
		            </div>
		        </div>
		    </div>
		</div>
		<!--底部导航-->
		<bottominfo></bottominfo>
	</div>
</template>

<script>
	import headinfo from '../components/headinfo.vue'
	import bottominfo from '../components/bottominfo.vue'
	import {getTeamList} from '../api/index.js'
	import {getDetails} from '../api/index.js'
	export default {
		name: "Personnel",
		components:{
			headinfo,
			bottominfo,
		},
		metaInfo: {
			title: '公证员风采-邯郸市诚信公证处',
			meta: [{
				name: 'keyWords',
				content: '公证员风采'
			}],
		},
		data() {
			return {
				open:false,
				tabledata:null,
				hoturl:'/cxWebApi/profile',
				info:null
			}
		},
		created() {
			this.getinfo();
		},
		methods:{
			showimg(row){
				getDetails({
					type:'team',
					id:row
				}).then(res=>{
					this.info = res.data
					this.open =true;
				})
			},
			getinfo(){
				getTeamList().then(res=>{
					this.tabledata = res.data
				})
			}
		}
	}
</script>

<style scoped>
	@import "../assets/css/reset.css";
	@import "../assets/css/new_file.css";
	>>> .ryjjdialog{
		min-height: 650px !important;
		border-radius: 10px;
	}
	>>> .ryjjdialog .el-dialog__header{
		padding: 0px !important;
	}
	>>> .ryjjdialog .el-dialog__body{
		padding: 0px !important;
	}
	>>>.center-container-right-words p{
		text-align: left !important;
		border-bottom: 0px !important;
	}
	>>>.center-container-right-words p strong{
		font-weight: 600;
	}
</style>
